import { createFileRoute } from '@tanstack/react-router';
import { WellnessFilter } from '@repo/shared/dtos/analytics/AnalyticsFilterDto';
import { checkAnalyticsSecurityDomain } from '../../components/analytics/utils/routeGuards';
import AnalyticsPageLayout from '../../components/analytics/shared/AnalyticsPageLayout';
import { getCategoryById } from '../../components/analytics/config';
import WellnessDashboard from '../../components/analytics/wellness/WellnessDashboard';
import { useAnalyticsFilters } from '../../components/analytics/filters';
import { useWellnessFormFilter } from '../../hooks/analytics/useSelectedWellnessForm';

export const Route = createFileRoute('/team-insights/wellness')({
  component: RouteComponent,
  beforeLoad: checkAnalyticsSecurityDomain({
    routeObject: 'analytics',
  }),
});

function RouteComponent() {
  const { filters, updateFilters } = useAnalyticsFilters();
  const category = getCategoryById('wellness');

  const selectionFilters: WellnessFilter = {
    startDate: filters.startDate,
    endDate: filters.endDate,
    experienceTitle: filters.experienceTitle,
    unitIds: filters.unitIds,
    experienceIds: filters.experienceIds,
  };
  const formId = useWellnessFormFilter(selectionFilters);
  const wellnessFilters: WellnessFilter = { ...selectionFilters, formId };

  if (!category) {
    return <div>Category not found</div>;
  }

  return (
    <AnalyticsPageLayout category={category} filters={filters} onFiltersChange={updateFilters}>
      <WellnessDashboard filters={wellnessFilters} />
    </AnalyticsPageLayout>
  );
}
